module.exports = __webpack_public_path__ + "img/182.08b710e7.svg";